import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Store } from '@ngrx/store';

import { ModalsActions } from 'src/app/features/modals';
import { RootStoreState } from 'src/app/store';

@Component({
  selector: 'app-document-acknowledgement-alert',
  templateUrl: './document-acknowledgement-alert.component.html',
  styleUrls: ['./document-acknowledgement-alert.component.scss'],
  standalone: false,
})
export class DocumentAcknowledgementAlertComponent {
  static identifier = 'DocumentAcknowledgementAlertComponent';

  @Input() onAcknowledge: () => void;
  @Input() onCancel: () => void;

  @Output() acknowledge = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  constructor(private readonly store: Store<RootStoreState.State>) {}

  acknowledgeClick() {
    this.onAcknowledge?.();
    this.acknowledge.emit();
    this.store.dispatch(ModalsActions.ClearModalComponent());
  }

  cancelClick() {
    this.onCancel?.();
    this.cancelled.emit();
    this.store.dispatch(ModalsActions.ClearModalComponent());
  }

  static openModal(
    store: Store<RootStoreState.State>,
    componentData: {
      onAcknowledge?: () => void;
      onCancel?: () => void;
    }
  ) {
    store.dispatch(
      ModalsActions.SetStandaloneModalComponent({
        payload: {
          component: DocumentAcknowledgementAlertComponent,
          componentData,
          shouldFade: true,
        },
      })
    );
  }
}
